import { render, staticRenderFns } from "./Mirror.vue?vue&type=template&id=9533b94c"
import script from "./Mirror.vue?vue&type=script&lang=js"
export * from "./Mirror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports